import {
  Button,
  Col,
  DatePicker,
  Descriptions,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Typography,
  Card,
} from "antd";
import Meta from "antd/es/card/Meta";
import { Content } from "antd/es/layout/layout";
import React, { useContext, useState } from "react";
import { getSalesHistory, getSalesSummary } from "../../utils/api/ReportsAPI";
import { UserContext } from "../../utils/context/UserContext";

import { getSalesSummaryReportHeader } from "../../utils/tableData/Report/SalesSummaryReport";
import { GlobalContext } from "../../App";
import { WARNING_NOTIFICATION_TYPE } from "../../utils/api/_ConstantsAPI";
import { PDFViewer } from "@react-pdf/renderer";

import { SalesSummaryPrint } from "../../components";
import { PrinterFilled } from "@ant-design/icons";
import dayjs from "dayjs";

export default function SalesSummaryReport() {
  const { Title } = Typography;
  // const { profile,getCurrentDate } = useContext(UserContext);
  const { profile, formItemLayout, getCurrentDate } = useContext(UserContext);
  const { openNotification } = useContext(GlobalContext);
  const [isLoading, setIsLoading] = useState(false);

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [currentDate, setcurrentDate] = useState(dayjs().format("YYYY-MM-DD"));

  const [localSalesSummaryRetail, setlocalSalesSummaryRetail] = useState([]);
  const [localSalesSummaryWS, setlocalSalesSummaryWS] = useState([]);
  const [localSalesSummaryOutlet, setlocalSalesSummaryOutlet] = useState([]);

  const [localSalesSummary, setlocalSalesSummary] = useState([]);

  const [selectedTransType, setSelectedTransType] = useState("");

  const [selectedSalesHistory, setSelectedSalesHistory] = useState({});
  const [isDetailedModalOpen, setIsDetailedModalOpen] = useState(false);

  const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);

  const tableContentsRetail = localSalesSummaryRetail.map((data, index) => ({
    ...data,
    key: index,
    id: index,
  }));

  const tableContentsWS = localSalesSummaryWS.map((data, index) => ({
    ...data,
    key: index,
    id: index,
  }));

  const tableContentsOutlet = localSalesSummaryOutlet.map((data, index) => ({
    ...data,
    key: index,
    id: index,
  }));

  const onProcessRequest = async () => {
    setIsLoading(true);
    const res = await getSalesSummary(profile.branchCode, dateFrom, dateTo);

    

    if (res.isSuccess) {
      if (res.data.length > 0) {
        const response = res?.data;
        const response2 = response?.[0];

        const retailData = response2?.summary_retail?.retail_data;
        const wholesaleData = response2?.summary_ws?.ws_data;
        const outletData = response2?.summary_outlet?.outlet_data;

        setlocalSalesSummaryRetail(retailData);
        setlocalSalesSummaryWS(wholesaleData);
        setlocalSalesSummaryOutlet(outletData);

        //All data
        setlocalSalesSummary(response2);
      }
    } else {
      setlocalSalesSummaryRetail([]);
      setlocalSalesSummaryWS([]);
      setlocalSalesSummaryOutlet([]);
      openNotification(WARNING_NOTIFICATION_TYPE, "Sales History", res.message);
    }
    setIsLoading(false);
  };

  return (
    <Content>
      <Typography.Title level={3}>Sales Summary</Typography.Title>
      <Row>
        <Col xs={24} sm={18}>
          <Space.Compact style={{ width: "100%" }}>
            <DatePicker
              // value={dayjs(currentDate)}
              onChange={(_, dateString) => {
                setDateFrom(dateString);
                // setDateTo(dateString);
              }}
              format="YYYY-MM-DD"
              disabled={isLoading}
            />
            <DatePicker
              // value={dayjs(currentDate)}
              onChange={(_, dateString) => {
                // setDateFrom(dateString);
                setDateTo(dateString);
              }}
              format="YYYY-MM-DD"
              disabled={isLoading}
            />
            <Button
              type="primary"
              disabled={isLoading || dateFrom === "" || dateTo === ""}
              onClick={() => onProcessRequest()}
            >
              Process
            </Button>
          </Space.Compact>
        </Col>
        <Col sm={6}>
          <Button
            block
            icon={<PrinterFilled />}
            onClick={() => setIsPrintModalOpen(true)}
            // disabled={localSalesSummary?.length === 0 || isLoading}
          >
            Print
          </Button>
        </Col>
      </Row>

      <Title level={4} className="mb-2 text-center" style={{ color: "red" }}>
        Retail
      </Title>

      <Table
        columns={getSalesSummaryReportHeader()}
        dataSource={tableContentsRetail}
        size="small"
        bordered="true"
        scroll={{ x: true, y: 350 }}
        loading={isLoading}
        className="mt-3"
      />
      <Title
        level={4}
        className="mb-2 pt-1 text-center"
        style={{ color: "red" }}
      >
        Wholesale
      </Title>
      <Table
        columns={getSalesSummaryReportHeader()}
        dataSource={tableContentsWS}
        size="small"
        bordered="true"
        scroll={{ x: true, y: 350 }}
        loading={isLoading}
        className="mt-3"
      />

      <Title
        level={4}
        className="mb-2 pt-1 text-center"
        style={{ color: "red" }}
      >
        Outlet
      </Title>
      <Table
        columns={getSalesSummaryReportHeader()}
        dataSource={tableContentsOutlet}
        size="small"
        bordered="true"
        scroll={{ x: true, y: 350 }}
        loading={isLoading}
        className="mt-3"
      />

      <Modal
        centered
        closable={false}
        open={isPrintModalOpen}
        confirmLoading={isLoading}
        onCancel={() => setIsPrintModalOpen(false)}
        cancelText="Close"
        okButtonProps={{ hidden: true }}
        width={"90vw"}
      >
        <PDFViewer style={{ width: "100%", height: "100vh" }}>
          <SalesSummaryPrint
            type={selectedTransType}
            records={localSalesSummary}
            date={dateFrom}
            dateto={dateTo}
            profile={profile}
          />
        </PDFViewer>
      </Modal>
    </Content>
  );
}
